import axios from 'axios';
import authHeader from './../auth-header';
import { API_URL } from './../API_URL';

class MilitaryEducation{

    GetAllCourses(StudentID){
        return axios.get(API_URL+`MilitaryEducation/GetCourses?StudentId=${StudentID}`,
       
        {  headers: authHeader() })
    }
    GetStudentReservation(StudentID){
        return axios.get(API_URL+`MilitaryEducation/GetStudentReservationInfo?StudentId=${StudentID}`,
       
        {  headers: authHeader() })
    }
    CancelStudentReservation(ReservationID,StudentId){
        return axios.post(API_URL+`MilitaryEducation/CancelReservation?StudentReservationId=${ReservationID}&StudentId=${StudentId}`,
       
        {  headers: authHeader() })
    }
   
    PostStudentReservation(ConfirmObj){
        return axios.post(API_URL+`MilitaryEducation/InsertReservation`,
        {
          
           studentid: ConfirmObj.studentid,
           CourseId: ConfirmObj.CourseId,
          
           
        },
       
        {  headers: authHeader() })
    } 
   

}

export default new MilitaryEducation();